import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

function LinkButton({ disabled, ...props }) {
  return !disabled ? <Link {...props} /> : <Button disabled style={{ position: 'relative' }} {...props} />;
}

export default LinkButton;
